<template>
  <div class="network-graph-outer">
    <div class="network-graph-container">
      <blockquote>Network visualizer</blockquote>
      <div class="pull-right">
        <div class="btn btn-primary sq" @click="$emit('close-graph')">
          Back to rates
        </div>
      </div>
      <div :id="graphId" class="network-graph">

      </div>
      <div class="pull-right">
        <div class="btn btn-primary sq btm-rgt" @click="download">
          Download <i class="fa fa-download"></i>
        </div>
      </div>
      <a href="" download class="download-a">
      </a>
      <small>* Please note, the grpah above is representative of the initial routes and <strong>WILL NOT</strong> update on route segment changes via workbench</small>
    </div>
  </div>
</template>
<script>
  import cytoscape from 'cytoscape'
  import $ from 'jquery'
  import event from '../../../event'
  import FileSaver from 'file-saver'
  export default {
    name: 'NetworkGraph',
    props: [ 'graphData', 'visible', 'highlight' ],
    data () {
      return {
        paths: [
          {
            'path': [
              {
                'id': 'RESIDENCE_68385_WAREHOUSE_62817_984_0',
                'expenseType': '(OA) Origin Agent',
                'source': 'DETROIT',
                'target': 'FARMINGTON HILLS',
                'label': '984.0',
                'weight': 984.0,
                'carrier': 'UNIVERSITY MVG & STGE *',
                'days': 2
              },
              {
                'id': 'WAREHOUSE_62817_TERMINAL_67852_628_33',
                'expenseType': '(OI) (OI) Origin Inland',
                'source': 'FARMINGTON HILLS',
                'target': 'LAREDO',
                'label': '628.33',
                'weight': 628.33,
                'carrier': 'CTS / Roadrunner',
                'days': 5
              },
              {
                'id': 'TERMINAL_67852_TERMINAL_POSTOP_67852_0_01',
                'expenseType': '(OP) Origin Port Services',
                'source': 'LAREDO',
                'target': 'LAREDO',
                'label': '0.01',
                'weight': 0.01,
                'carrier': 'ROJAS FORWARDING INC.    ',
                'days': 3
              },
              {
                'id': 'TERMINAL_POSTOP_67852_RESIDENCE_69160_1140_0',
                'expenseType': '(DZ) Destination All In',
                'source': 'LAREDO',
                'target': 'Mexico City',
                'label': '1140.0',
                'weight': 1140.0,
                'carrier': 'Moreno International SA DE CV',
                'days': 21
              }
            ],
            'totalWeight': 2752.34,
            'totalDays': 31
          },
          {
            'path': [
              {
                'id': 'RESIDENCE_68385_WAREHOUSE_67171_997_8',
                'expenseType': '(OA) Origin Agent',
                'source': 'DETROIT',
                'target': 'WARREN',
                'label': '997.8',
                'weight': 997.8,
                'carrier': 'PALMER MOVING & STG *      ',
                'days': 2
              },
              {
                'id': 'WAREHOUSE_67171_TERMINAL_67852_628_33',
                'expenseType': '(OI) (OI) Origin Inland',
                'source': 'WARREN',
                'target': 'LAREDO',
                'label': '628.33',
                'weight': 628.33,
                'carrier': 'CTS / Roadrunner',
                'days': 5
              },
              {
                'id': 'TERMINAL_67852_TERMINAL_POSTOP_67852_0_01',
                'expenseType': '(OP) Origin Port Services',
                'source': 'LAREDO',
                'target': 'LAREDO',
                'label': '0.01',
                'weight': 0.01,
                'carrier': 'ROJAS FORWARDING INC.    ',
                'days': 3
              },
              {
                'id': 'TERMINAL_POSTOP_67852_RESIDENCE_69160_1140_0',
                'expenseType': '(DZ) Destination All In',
                'source': 'LAREDO',
                'target': 'Mexico City',
                'label': '1140.0',
                'weight': 1140.0,
                'carrier': 'Moreno International SA DE CV',
                'days': 21
              }
            ],
            'totalWeight': 2766.14,
            'totalDays': 31
          },
          {
            'path': [
              {
                'id': 'RESIDENCE_68385_WAREHOUSE_81296_1020_0',
                'expenseType': '(OA) Origin Agent',
                'source': 'DETROIT',
                'target': 'BELLEVILLE',
                'label': '1020.0',
                'weight': 1020.0,
                'carrier': 'Allied Intl Detroit Rose',
                'days': 2
              },
              {
                'id': 'WAREHOUSE_81296_TERMINAL_67852_628_33',
                'expenseType': '(OI) (OI) Origin Inland',
                'source': 'BELLEVILLE',
                'target': 'LAREDO',
                'label': '628.33',
                'weight': 628.33,
                'carrier': 'CTS / Roadrunner',
                'days': 5
              },
              {
                'id': 'TERMINAL_67852_TERMINAL_POSTOP_67852_0_01',
                'expenseType': '(OP) Origin Port Services',
                'source': 'LAREDO',
                'target': 'LAREDO',
                'label': '0.01',
                'weight': 0.01,
                'carrier': 'ROJAS FORWARDING INC.    ',
                'days': 3
              },
              {
                'id': 'TERMINAL_POSTOP_67852_RESIDENCE_69160_1140_0',
                'expenseType': '(DZ) Destination All In',
                'source': 'LAREDO',
                'target': 'Mexico City',
                'label': '1140.0',
                'weight': 1140.0,
                'carrier': 'Moreno International SA DE CV',
                'days': 21
              }
            ],
            'totalWeight': 2788.34,
            'totalDays': 31
          },
          {
            'path': [
              {
                'id': 'RESIDENCE_68385_WAREHOUSE_67380_1020_0',
                'expenseType': '(OA) Origin Agent',
                'source': 'DETROIT',
                'target': 'ROMULUS',
                'label': '1020.0',
                'weight': 1020.0,
                'carrier': 'Allied Intl Detroit Morse',
                'days': 2
              },
              {
                'id': 'WAREHOUSE_67380_TERMINAL_67852_628_33',
                'expenseType': '(OI) (OI) Origin Inland',
                'source': 'ROMULUS',
                'target': 'LAREDO',
                'label': '628.33',
                'weight': 628.33,
                'carrier': 'CTS / Roadrunner',
                'days': 5
              },
              {
                'id': 'TERMINAL_67852_TERMINAL_POSTOP_67852_0_01',
                'expenseType': '(OP) Origin Port Services',
                'source': 'LAREDO',
                'target': 'LAREDO',
                'label': '0.01',
                'weight': 0.01,
                'carrier': 'ROJAS FORWARDING INC.    ',
                'days': 3
              },
              {
                'id': 'TERMINAL_POSTOP_67852_RESIDENCE_69160_1140_0',
                'expenseType': '(DZ) Destination All In',
                'source': 'LAREDO',
                'target': 'Mexico City',
                'label': '1140.0',
                'weight': 1140.0,
                'carrier': 'Moreno International SA DE CV',
                'days': 21
              }
            ],
            'totalWeight': 2788.34,
            'totalDays': 31
          },
          {
            'path': [
              {
                'id': 'RESIDENCE_68385_WAREHOUSE_68041_936_0',
                'expenseType': '(OA) Origin Agent',
                'source': 'DETROIT',
                'target': 'JACKSON',
                'label': '936.0',
                'weight': 936.0,
                'carrier': 'CALLAN & WOODWORTH M/S   ',
                'days': 2
              },
              {
                'id': 'WAREHOUSE_68041_TERMINAL_67852_1191_02',
                'expenseType': '(OI) (OI) Origin Inland',
                'source': 'JACKSON',
                'target': 'LAREDO',
                'label': '1191.02',
                'weight': 1191.02,
                'carrier': 'CTS / SAIA Motor',
                'days': 3
              },
              {
                'id': 'TERMINAL_67852_TERMINAL_POSTOP_67852_0_01',
                'expenseType': '(OP) Origin Port Services',
                'source': 'LAREDO',
                'target': 'LAREDO',
                'label': '0.01',
                'weight': 0.01,
                'carrier': 'ROJAS FORWARDING INC.    ',
                'days': 3
              },
              {
                'id': 'TERMINAL_POSTOP_67852_RESIDENCE_69160_1140_0',
                'expenseType': '(DZ) Destination All In',
                'source': 'LAREDO',
                'target': 'Mexico City',
                'label': '1140.0',
                'weight': 1140.0,
                'carrier': 'Moreno International SA DE CV',
                'days': 21
              }
            ],
            'totalWeight': 3267.03,
            'totalDays': 29
          },
          {
            'path': [
              {
                'id': 'RESIDENCE_68385_WAREHOUSE_62817_984_0',
                'expenseType': '(OA) Origin Agent',
                'source': 'DETROIT',
                'target': 'FARMINGTON HILLS',
                'label': '984.0',
                'weight': 984.0,
                'carrier': 'UNIVERSITY MVG & STGE *',
                'days': 2
              },
              {
                'id': 'WAREHOUSE_62817_TERMINAL_67852_1219_75',
                'expenseType': '(OI) (OI) Origin Inland',
                'source': 'FARMINGTON HILLS',
                'target': 'LAREDO',
                'label': '1219.75',
                'weight': 1219.75,
                'carrier': 'CTS / SAIA Motor',
                'days': 3
              },
              {
                'id': 'TERMINAL_67852_TERMINAL_POSTOP_67852_0_01',
                'expenseType': '(OP) Origin Port Services',
                'source': 'LAREDO',
                'target': 'LAREDO',
                'label': '0.01',
                'weight': 0.01,
                'carrier': 'ROJAS FORWARDING INC.    ',
                'days': 3
              },
              {
                'id': 'TERMINAL_POSTOP_67852_RESIDENCE_69160_1140_0',
                'expenseType': '(DZ) Destination All In',
                'source': 'LAREDO',
                'target': 'Mexico City',
                'label': '1140.0',
                'weight': 1140.0,
                'carrier': 'Moreno International SA DE CV',
                'days': 21
              }
            ],
            'totalWeight': 3343.76,
            'totalDays': 29
          },
          {
            'path': [
              {
                'id': 'RESIDENCE_68385_WAREHOUSE_67171_997_8',
                'expenseType': '(OA) Origin Agent',
                'source': 'DETROIT',
                'target': 'WARREN',
                'label': '997.8',
                'weight': 997.8,
                'carrier': 'PALMER MOVING & STG *      ',
                'days': 2
              },
              {
                'id': 'WAREHOUSE_67171_TERMINAL_67852_1219_75',
                'expenseType': '(OI) (OI) Origin Inland',
                'source': 'WARREN',
                'target': 'LAREDO',
                'label': '1219.75',
                'weight': 1219.75,
                'carrier': 'CTS / SAIA Motor',
                'days': 3
              },
              {
                'id': 'TERMINAL_67852_TERMINAL_POSTOP_67852_0_01',
                'expenseType': '(OP) Origin Port Services',
                'source': 'LAREDO',
                'target': 'LAREDO',
                'label': '0.01',
                'weight': 0.01,
                'carrier': 'ROJAS FORWARDING INC.    ',
                'days': 3
              },
              {
                'id': 'TERMINAL_POSTOP_67852_RESIDENCE_69160_1140_0',
                'expenseType': '(DZ) Destination All In',
                'source': 'LAREDO',
                'target': 'Mexico City',
                'label': '1140.0',
                'weight': 1140.0,
                'carrier': 'Moreno International SA DE CV',
                'days': 21
              }
            ],
            'totalWeight': 3357.56,
            'totalDays': 29
          },
          {
            'path': [
              {
                'id': 'RESIDENCE_68385_WAREHOUSE_62817_984_0',
                'expenseType': '(OA) Origin Agent',
                'source': 'DETROIT',
                'target': 'FARMINGTON HILLS',
                'label': '984.0',
                'weight': 984.0,
                'carrier': 'UNIVERSITY MVG & STGE *',
                'days': 2
              },
              {
                'id': 'WAREHOUSE_62817_TERMINAL_67852_628_33',
                'expenseType': '(OI) (OI) Origin Inland',
                'source': 'FARMINGTON HILLS',
                'target': 'LAREDO',
                'label': '628.33',
                'weight': 628.33,
                'carrier': 'CTS / Roadrunner',
                'days': 5
              },
              {
                'id': 'TERMINAL_67852_TERMINAL_POSTOP_67852_0_01',
                'expenseType': '(OP) Origin Port Services',
                'source': 'LAREDO',
                'target': 'LAREDO',
                'label': '0.01',
                'weight': 0.01,
                'carrier': 'ROJAS FORWARDING INC.    ',
                'days': 3
              },
              {
                'id': 'TERMINAL_POSTOP_67852_RESIDENCE_69160_1766_78',
                'expenseType': '(DZ) Destination All In',
                'source': 'LAREDO',
                'target': 'Mexico City',
                'label': '1766.78',
                'weight': 1766.78,
                'carrier': 'MUDANZAS GOU S.A. DE C.V.',
                'days': 21
              }
            ],
            'totalWeight': 3379.12,
            'totalDays': 31
          },
          {
            'path': [
              {
                'id': 'RESIDENCE_68385_WAREHOUSE_81296_1020_0',
                'expenseType': '(OA) Origin Agent',
                'source': 'DETROIT',
                'target': 'BELLEVILLE',
                'label': '1020.0',
                'weight': 1020.0,
                'carrier': 'Allied Intl Detroit Rose',
                'days': 2
              },
              {
                'id': 'WAREHOUSE_81296_TERMINAL_67852_1219_75',
                'expenseType': '(OI) (OI) Origin Inland',
                'source': 'BELLEVILLE',
                'target': 'LAREDO',
                'label': '1219.75',
                'weight': 1219.75,
                'carrier': 'CTS / SAIA Motor',
                'days': 3
              },
              {
                'id': 'TERMINAL_67852_TERMINAL_POSTOP_67852_0_01',
                'expenseType': '(OP) Origin Port Services',
                'source': 'LAREDO',
                'target': 'LAREDO',
                'label': '0.01',
                'weight': 0.01,
                'carrier': 'ROJAS FORWARDING INC.    ',
                'days': 3
              },
              {
                'id': 'TERMINAL_POSTOP_67852_RESIDENCE_69160_1140_0',
                'expenseType': '(DZ) Destination All In',
                'source': 'LAREDO',
                'target': 'Mexico City',
                'label': '1140.0',
                'weight': 1140.0,
                'carrier': 'Moreno International SA DE CV',
                'days': 21
              }
            ],
            'totalWeight': 3379.76,
            'totalDays': 29
          },
          {
            'path': [
              {
                'id': 'RESIDENCE_68385_WAREHOUSE_67380_1020_0',
                'expenseType': '(OA) Origin Agent',
                'source': 'DETROIT',
                'target': 'ROMULUS',
                'label': '1020.0',
                'weight': 1020.0,
                'carrier': 'Allied Intl Detroit Morse',
                'days': 2
              },
              {
                'id': 'WAREHOUSE_67380_TERMINAL_67852_1219_75',
                'expenseType': '(OI) (OI) Origin Inland',
                'source': 'ROMULUS',
                'target': 'LAREDO',
                'label': '1219.75',
                'weight': 1219.75,
                'carrier': 'CTS / SAIA Motor',
                'days': 3
              },
              {
                'id': 'TERMINAL_67852_TERMINAL_POSTOP_67852_0_01',
                'expenseType': '(OP) Origin Port Services',
                'source': 'LAREDO',
                'target': 'LAREDO',
                'label': '0.01',
                'weight': 0.01,
                'carrier': 'ROJAS FORWARDING INC.    ',
                'days': 3
              },
              {
                'id': 'TERMINAL_POSTOP_67852_RESIDENCE_69160_1140_0',
                'expenseType': '(DZ) Destination All In',
                'source': 'LAREDO',
                'target': 'Mexico City',
                'label': '1140.0',
                'weight': 1140.0,
                'carrier': 'Moreno International SA DE CV',
                'days': 21
              }
            ],
            'totalWeight': 3379.76,
            'totalDays': 29
          },
          {
            'path': [
              {
                'id': 'RESIDENCE_68385_WAREHOUSE_67171_997_8',
                'expenseType': '(OA) Origin Agent',
                'source': 'DETROIT',
                'target': 'WARREN',
                'label': '997.8',
                'weight': 997.8,
                'carrier': 'PALMER MOVING & STG *      ',
                'days': 2
              },
              {
                'id': 'WAREHOUSE_67171_TERMINAL_67852_628_33',
                'expenseType': '(OI) (OI) Origin Inland',
                'source': 'WARREN',
                'target': 'LAREDO',
                'label': '628.33',
                'weight': 628.33,
                'carrier': 'CTS / Roadrunner',
                'days': 5
              },
              {
                'id': 'TERMINAL_67852_TERMINAL_POSTOP_67852_0_01',
                'expenseType': '(OP) Origin Port Services',
                'source': 'LAREDO',
                'target': 'LAREDO',
                'label': '0.01',
                'weight': 0.01,
                'carrier': 'ROJAS FORWARDING INC.    ',
                'days': 3
              },
              {
                'id': 'TERMINAL_POSTOP_67852_RESIDENCE_69160_1766_78',
                'expenseType': '(DZ) Destination All In',
                'source': 'LAREDO',
                'target': 'Mexico City',
                'label': '1766.78',
                'weight': 1766.78,
                'carrier': 'MUDANZAS GOU S.A. DE C.V.',
                'days': 21
              }
            ],
            'totalWeight': 3392.92,
            'totalDays': 31
          },
          {
            'path': [
              {
                'id': 'RESIDENCE_68385_WAREHOUSE_81296_1020_0',
                'expenseType': '(OA) Origin Agent',
                'source': 'DETROIT',
                'target': 'BELLEVILLE',
                'label': '1020.0',
                'weight': 1020.0,
                'carrier': 'Allied Intl Detroit Rose',
                'days': 2
              },
              {
                'id': 'WAREHOUSE_81296_TERMINAL_67852_628_33',
                'expenseType': '(OI) (OI) Origin Inland',
                'source': 'BELLEVILLE',
                'target': 'LAREDO',
                'label': '628.33',
                'weight': 628.33,
                'carrier': 'CTS / Roadrunner',
                'days': 5
              },
              {
                'id': 'TERMINAL_67852_TERMINAL_POSTOP_67852_0_01',
                'expenseType': '(OP) Origin Port Services',
                'source': 'LAREDO',
                'target': 'LAREDO',
                'label': '0.01',
                'weight': 0.01,
                'carrier': 'ROJAS FORWARDING INC.    ',
                'days': 3
              },
              {
                'id': 'TERMINAL_POSTOP_67852_RESIDENCE_69160_1766_78',
                'expenseType': '(DZ) Destination All In',
                'source': 'LAREDO',
                'target': 'Mexico City',
                'label': '1766.78',
                'weight': 1766.78,
                'carrier': 'MUDANZAS GOU S.A. DE C.V.',
                'days': 21
              }
            ],
            'totalWeight': 3415.12,
            'totalDays': 31
          },
          {
            'path': [
              {
                'id': 'RESIDENCE_68385_WAREHOUSE_67380_1020_0',
                'expenseType': '(OA) Origin Agent',
                'source': 'DETROIT',
                'target': 'ROMULUS',
                'label': '1020.0',
                'weight': 1020.0,
                'carrier': 'Allied Intl Detroit Morse',
                'days': 2
              },
              {
                'id': 'WAREHOUSE_67380_TERMINAL_67852_628_33',
                'expenseType': '(OI) (OI) Origin Inland',
                'source': 'ROMULUS',
                'target': 'LAREDO',
                'label': '628.33',
                'weight': 628.33,
                'carrier': 'CTS / Roadrunner',
                'days': 5
              },
              {
                'id': 'TERMINAL_67852_TERMINAL_POSTOP_67852_0_01',
                'expenseType': '(OP) Origin Port Services',
                'source': 'LAREDO',
                'target': 'LAREDO',
                'label': '0.01',
                'weight': 0.01,
                'carrier': 'ROJAS FORWARDING INC.    ',
                'days': 3
              },
              {
                'id': 'TERMINAL_POSTOP_67852_RESIDENCE_69160_1766_78',
                'expenseType': '(DZ) Destination All In',
                'source': 'LAREDO',
                'target': 'Mexico City',
                'label': '1766.78',
                'weight': 1766.78,
                'carrier': 'MUDANZAS GOU S.A. DE C.V.',
                'days': 21
              }
            ],
            'totalWeight': 3415.12,
            'totalDays': 31
          },
          {
            'path': [
              {
                'id': 'RESIDENCE_68385_WAREHOUSE_68041_936_0',
                'expenseType': '(OA) Origin Agent',
                'source': 'DETROIT',
                'target': 'JACKSON',
                'label': '936.0',
                'weight': 936.0,
                'carrier': 'CALLAN & WOODWORTH M/S   ',
                'days': 2
              },
              {
                'id': 'WAREHOUSE_68041_TERMINAL_67852_1341_83',
                'expenseType': '(OI) (OI) Origin Inland',
                'source': 'JACKSON',
                'target': 'LAREDO',
                'label': '1341.83',
                'weight': 1341.83,
                'carrier': 'CTS / SAIA Motor',
                'days': 3
              },
              {
                'id': 'TERMINAL_67852_TERMINAL_POSTOP_67852_0_01',
                'expenseType': '(OP) Origin Port Services',
                'source': 'LAREDO',
                'target': 'LAREDO',
                'label': '0.01',
                'weight': 0.01,
                'carrier': 'ROJAS FORWARDING INC.    ',
                'days': 3
              },
              {
                'id': 'TERMINAL_POSTOP_67852_RESIDENCE_69160_1140_0',
                'expenseType': '(DZ) Destination All In',
                'source': 'LAREDO',
                'target': 'Mexico City',
                'label': '1140.0',
                'weight': 1140.0,
                'carrier': 'Moreno International SA DE CV',
                'days': 21
              }
            ],
            'totalWeight': 3417.84,
            'totalDays': 29
          },
          {
            'path': [
              {
                'id': 'RESIDENCE_68385_WAREHOUSE_62817_984_0',
                'expenseType': '(OA) Origin Agent',
                'source': 'DETROIT',
                'target': 'FARMINGTON HILLS',
                'label': '984.0',
                'weight': 984.0,
                'carrier': 'UNIVERSITY MVG & STGE *',
                'days': 2
              },
              {
                'id': 'WAREHOUSE_62817_TERMINAL_67852_1374_2',
                'expenseType': '(OI) (OI) Origin Inland',
                'source': 'FARMINGTON HILLS',
                'target': 'LAREDO',
                'label': '1374.2',
                'weight': 1374.2,
                'carrier': 'CTS / SAIA Motor',
                'days': 3
              },
              {
                'id': 'TERMINAL_67852_TERMINAL_POSTOP_67852_0_01',
                'expenseType': '(OP) Origin Port Services',
                'source': 'LAREDO',
                'target': 'LAREDO',
                'label': '0.01',
                'weight': 0.01,
                'carrier': 'ROJAS FORWARDING INC.    ',
                'days': 3
              },
              {
                'id': 'TERMINAL_POSTOP_67852_RESIDENCE_69160_1140_0',
                'expenseType': '(DZ) Destination All In',
                'source': 'LAREDO',
                'target': 'Mexico City',
                'label': '1140.0',
                'weight': 1140.0,
                'carrier': 'Moreno International SA DE CV',
                'days': 21
              }
            ],
            'totalWeight': 3498.21,
            'totalDays': 29
          },
          {
            'path': [
              {
                'id': 'RESIDENCE_68385_WAREHOUSE_67171_997_8',
                'expenseType': '(OA) Origin Agent',
                'source': 'DETROIT',
                'target': 'WARREN',
                'label': '997.8',
                'weight': 997.8,
                'carrier': 'PALMER MOVING & STG *      ',
                'days': 2
              },
              {
                'id': 'WAREHOUSE_67171_TERMINAL_67852_1374_2',
                'expenseType': '(OI) (OI) Origin Inland',
                'source': 'WARREN',
                'target': 'LAREDO',
                'label': '1374.2',
                'weight': 1374.2,
                'carrier': 'CTS / SAIA Motor',
                'days': 3
              },
              {
                'id': 'TERMINAL_67852_TERMINAL_POSTOP_67852_0_01',
                'expenseType': '(OP) Origin Port Services',
                'source': 'LAREDO',
                'target': 'LAREDO',
                'label': '0.01',
                'weight': 0.01,
                'carrier': 'ROJAS FORWARDING INC.    ',
                'days': 3
              },
              {
                'id': 'TERMINAL_POSTOP_67852_RESIDENCE_69160_1140_0',
                'expenseType': '(DZ) Destination All In',
                'source': 'LAREDO',
                'target': 'Mexico City',
                'label': '1140.0',
                'weight': 1140.0,
                'carrier': 'Moreno International SA DE CV',
                'days': 21
              }
            ],
            'totalWeight': 3512.01,
            'totalDays': 29
          }
        ],
        nodes: [
          {
            'data': {
              'id': 'RESIDENCE_68385',
              'name': 'DETROIT residence',
              'shape': 'ellipse',
              'bgcolor': 'cyan'
            }
          },
          {
            'data': {
              'id': 'WAREHOUSE_62817',
              'name': 'FARMINGTON HILLS warehouse',
              'shape': 'rectangle',
              'bgcolor': 'pink'
            }
          },
          {
            'data': {
              'id': 'TERMINAL_67852',
              'name': 'LAREDO terminal',
              'shape': 'pentagon',
              'bgcolor': 'green'
            }
          },
          {
            'data': {
              'id': 'TERMINAL_POSTOP_67852',
              'name': 'LAREDO terminal_postop',
              'shape': 'ellipse',
              'bgcolor': 'cyan'
            }
          },
          {
            'data': {
              'id': 'RESIDENCE_69160',
              'name': 'Mexico City residence',
              'shape': 'ellipse',
              'bgcolor': 'cyan'
            }
          },
          {
            'data': {
              'id': 'WAREHOUSE_67171',
              'name': 'WARREN warehouse',
              'shape': 'rectangle',
              'bgcolor': 'pink'
            }
          },
          {
            'data': {
              'id': 'WAREHOUSE_81296',
              'name': 'BELLEVILLE warehouse',
              'shape': 'rectangle',
              'bgcolor': 'pink'
            }
          },
          {
            'data': {
              'id': 'WAREHOUSE_67380',
              'name': 'ROMULUS warehouse',
              'shape': 'rectangle',
              'bgcolor': 'pink'
            }
          },
          {
            'data': {
              'id': 'WAREHOUSE_68041',
              'name': 'JACKSON warehouse',
              'shape': 'rectangle',
              'bgcolor': 'pink'
            }
          }
        ],
        edges: [
          {
            'data': {
              'id': 'RESIDENCE_68385_WAREHOUSE_62817_984_0',
              'source': 'RESIDENCE_68385',
              'target': 'WAREHOUSE_62817',
              'label': '984.0',
              'weight': 984.0
            }
          },
          {
            'data': {
              'id': 'WAREHOUSE_62817_TERMINAL_67852_628_33',
              'source': 'WAREHOUSE_62817',
              'target': 'TERMINAL_67852',
              'label': '628.33',
              'weight': 628.33
            }
          },
          {
            'data': {
              'id': 'TERMINAL_67852_TERMINAL_POSTOP_67852_0_01',
              'source': 'TERMINAL_67852',
              'target': 'TERMINAL_POSTOP_67852',
              'label': '0.01',
              'weight': 0.01
            }
          },
          {
            'data': {
              'id': 'TERMINAL_POSTOP_67852_RESIDENCE_69160_1140_0',
              'source': 'TERMINAL_POSTOP_67852',
              'target': 'RESIDENCE_69160',
              'label': '1140.0',
              'weight': 1140.0
            }
          },
          {
            'data': {
              'id': 'RESIDENCE_68385_WAREHOUSE_67171_997_8',
              'source': 'RESIDENCE_68385',
              'target': 'WAREHOUSE_67171',
              'label': '997.8',
              'weight': 997.8
            }
          },
          {
            'data': {
              'id': 'WAREHOUSE_67171_TERMINAL_67852_628_33',
              'source': 'WAREHOUSE_67171',
              'target': 'TERMINAL_67852',
              'label': '628.33',
              'weight': 628.33
            }
          },
          {
            'data': {
              'id': 'RESIDENCE_68385_WAREHOUSE_81296_1020_0',
              'source': 'RESIDENCE_68385',
              'target': 'WAREHOUSE_81296',
              'label': '1020.0',
              'weight': 1020.0
            }
          },
          {
            'data': {
              'id': 'WAREHOUSE_81296_TERMINAL_67852_628_33',
              'source': 'WAREHOUSE_81296',
              'target': 'TERMINAL_67852',
              'label': '628.33',
              'weight': 628.33
            }
          },
          {
            'data': {
              'id': 'RESIDENCE_68385_WAREHOUSE_67380_1020_0',
              'source': 'RESIDENCE_68385',
              'target': 'WAREHOUSE_67380',
              'label': '1020.0',
              'weight': 1020.0
            }
          },
          {
            'data': {
              'id': 'WAREHOUSE_67380_TERMINAL_67852_628_33',
              'source': 'WAREHOUSE_67380',
              'target': 'TERMINAL_67852',
              'label': '628.33',
              'weight': 628.33
            }
          },
          {
            'data': {
              'id': 'RESIDENCE_68385_WAREHOUSE_68041_936_0',
              'source': 'RESIDENCE_68385',
              'target': 'WAREHOUSE_68041',
              'label': '936.0',
              'weight': 936.0
            }
          },
          {
            'data': {
              'id': 'WAREHOUSE_68041_TERMINAL_67852_1191_02',
              'source': 'WAREHOUSE_68041',
              'target': 'TERMINAL_67852',
              'label': '1191.02',
              'weight': 1191.02
            }
          },
          {
            'data': {
              'id': 'WAREHOUSE_62817_TERMINAL_67852_1219_75',
              'source': 'WAREHOUSE_62817',
              'target': 'TERMINAL_67852',
              'label': '1219.75',
              'weight': 1219.75
            }
          },
          {
            'data': {
              'id': 'WAREHOUSE_67171_TERMINAL_67852_1219_75',
              'source': 'WAREHOUSE_67171',
              'target': 'TERMINAL_67852',
              'label': '1219.75',
              'weight': 1219.75
            }
          },
          {
            'data': {
              'id': 'TERMINAL_POSTOP_67852_RESIDENCE_69160_1766_78',
              'source': 'TERMINAL_POSTOP_67852',
              'target': 'RESIDENCE_69160',
              'label': '1766.78',
              'weight': 1766.78
            }
          },
          {
            'data': {
              'id': 'WAREHOUSE_81296_TERMINAL_67852_1219_75',
              'source': 'WAREHOUSE_81296',
              'target': 'TERMINAL_67852',
              'label': '1219.75',
              'weight': 1219.75
            }
          },
          {
            'data': {
              'id': 'WAREHOUSE_67380_TERMINAL_67852_1219_75',
              'source': 'WAREHOUSE_67380',
              'target': 'TERMINAL_67852',
              'label': '1219.75',
              'weight': 1219.75
            }
          },
          {
            'data': {
              'id': 'WAREHOUSE_68041_TERMINAL_67852_1341_83',
              'source': 'WAREHOUSE_68041',
              'target': 'TERMINAL_67852',
              'label': '1341.83',
              'weight': 1341.83
            }
          },
          {
            'data': {
              'id': 'WAREHOUSE_62817_TERMINAL_67852_1374_2',
              'source': 'WAREHOUSE_62817',
              'target': 'TERMINAL_67852',
              'label': '1374.2',
              'weight': 1374.2
            }
          },
          {
            'data': {
              'id': 'WAREHOUSE_67171_TERMINAL_67852_1374_2',
              'source': 'WAREHOUSE_67171',
              'target': 'TERMINAL_67852',
              'label': '1374.2',
              'weight': 1374.2
            }
          }
        ],
        style: [
          {
            selector: 'node',
            style: {
              'content': 'data(name)',
              'text-valign': 'center',
              'color': 'white',
              'text-outline-width': 1,
              'font-size': '5px',
              'background-color': '#999',
              'text-outline-color': '#999'
            }
          },
          {
            selector: 'edge',
            style: {
              'curve-style': 'bezier',
              'target-arrow-shape': 'triangle',
              'target-arrow-color': '#ccc',
              'line-color': '#ccc',
              'label': 'data(weight)',
              'font-size': '6px',
              'width': 1
            }
          }
        ],
        cy: null
      }
    },
    computed: {
      graphId () {
        return `network-graph-${this._uid}`
      }
    },
    watch: {
      highlight (newVal, oldVal) {
        this.highlightPath(newVal)
      }
    },
    methods: {
      download () {
        const a = this.$el.querySelector('.download-a')
        a.setAttribute('href', this.cy.png({ bg: '#fff' }))
        a.click()
      },
      resetAllEdges () {
        this.cy.edges().forEach(edge => edge.animate({ style: { lineColor: '#ccc', backgroundColor: '#ccc', targetArrowColor: '#ccc', width: 1 } }))
      },
      highlightPath (index) {
        let path = this.paths[index].path
        this.resetAllEdges()
        for (var i = 0; i < path.length; i++) {
          this.cy.$('#' + path[i].id).animate({ style: { lineColor: 'red', backgroundColor: 'red', targetArrowColor: 'red', width: 2 } })
        }
      },
      graphResize () {
        if (this.cy !== null) {
          this.cy.resize()
          this.cy.fit()
        }
      }
    },
    mounted () {
      this.nodes = this.graphData.nodes
      this.edges = this.graphData.edges
      this.paths = this.graphData.paths
      this.cy = cytoscape({
        container: $('#' + this.graphId),
        boxSelectionEnabled: false,
        autounselectify: true,
        panningEnabled: true,
        zoomingEnabled: true,
        wheelSensitivity: 0.15,
        zoom: 250,
        userPanningEnabled: true,
        elements: {
          nodes: this.nodes,
          edges: this.edges
        },
        style: this.style,
        layout: {
          name: 'cose',
          rows: 1
        }
      })
      this.$nextTick(() => {
        this.highlightPath(this.highlight)
      })
      event.$on('window-resizing', this.graphResize)
    },
    beforeDestroy () {
      event.$off('window-resizing', this.graphResize)
    }
  }
</script>
<style>
  .network-graph-container {
    position: relative;
    max-width: 100% !important;
    height: 90%;
    background-color: #fff;
    margin: 25px;
    padding: 10px;
  }
  .network-graph {
    height: 90vh;
    background: #eee;
    overflow: hidden;
  }
  .network-graph-container blockquote {
    display: inline-block;
  }
  @media only screen and (max-width : 768px) {
    .network-graph-container {
      margin: 5px;
      padding: 10px;
    }
  }
  @media only screen and (max-width : 480px) {
    .network-graph-container blockquote {
      display: block;
    }
    .network-graph-container .pull-right {
      float:none !important;
      display: block;
    }
    .network-graph-container .btn {
      width: 100%;
    }
  }
  .btm-rgt {
    position: relative;
    top: -34px;
  }
</style>



// WEBPACK FOOTER //
// NetworkGraph.vue?32c1d468